import React, { useState, useEffect } from 'react';
import { Table, Card, message, Space, Button } from 'antd';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { DownloadOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const pageSize = 10;
  useAuth();  // 只解构需要使用的 user 变量

  const fetchOrders = async (page = 1) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const skip = (page - 1) * pageSize;
      const response = await axios.get(`${API_BASE_URL}/orders/?skip=${skip}&limit=${pageSize}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // 如果返回的数据等于页面大小，说明可能还有更多数据
      const hasMoreData = response.data.length === pageSize;
      setHasMore(hasMoreData);
      setOrders(response.data);
      setCurrentPage(page);
    } catch (error) {
      message.error('获取订单列表失败：' + (error.response?.data?.detail || '未知错误'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      fetchOrders(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (hasMore) {
      fetchOrders(currentPage + 1);
    }
  };

  const getPdfUrl = (createdAt, uid) => {
    if (!createdAt || !uid) return null;
    const date = new Date(createdAt);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `https://label.k003tt.com/paket/${year}${month}/${uid}.pdf`;
  };

  const handleDownloadPdf = (url) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      message.error('PDF文件不存在');
    }
  };

  const columns = [
    {
      title: '参考单号',
      dataIndex: 'pid',
      key: 'pid',
    },
    {
      title: 'DHL单号',
      dataIndex: 'fullcode',
      key: 'fullcode',
    },
    {
      title: '发件人',
      key: 'sender',
      render: (_, record) => (
        <Space direction="vertical">
          <span>{record.sender_name}</span>
          <span>{record.sender_street} {record.sender_num}</span>
          <span>{record.sender_zip} {record.sender_city}</span>
          <span>{record.sender_country}</span>
        </Space>
      ),
    },
    {
      title: '收件人',
      key: 'receiver',
      render: (_, record) => (
        <Space direction="vertical">
          <span>{record.receiver_name}</span>
          <span>{record.receiver_street} {record.receiver_num}</span>
          <span>{record.receiver_zip} {record.receiver_city}</span>
          <span>{record.receiver_country}</span>
        </Space>
      ),
    },
    {
      title: '包裹重量',
      dataIndex: 'pack_weight',
      key: 'pack_weight',
      render: (weight) => `${weight} kg`,
    },
    {
      title: '下单时间',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => date ? new Date(date).toLocaleString() : '-',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => {
        const pdfUrl = getPdfUrl(record.created_at, record.uid);
        return (
          <Button
            type="link"
            icon={<DownloadOutlined />}
            onClick={() => handleDownloadPdf(pdfUrl)}
            disabled={!pdfUrl}
          >
            下载PDF
          </Button>
        );
      },
    },
  ];

  return (
    <Card title="订单列表">
      <Table
        columns={columns}
        dataSource={orders}
        rowKey="pid"
        pagination={false}
        loading={loading}
        scroll={{ x: true }}
      />
      <div style={{ marginTop: 16, textAlign: 'right' }}>
        <Space>
          <Button 
            icon={<LeftOutlined />} 
            onClick={handlePrevPage}
            disabled={currentPage === 1 || loading}
          >
            上一页
          </Button>
          <span>第 {currentPage} 页</span>
          <Button 
            icon={<RightOutlined />} 
            onClick={handleNextPage}
            disabled={!hasMore || loading}
          >
            下一页
          </Button>
        </Space>
      </div>
    </Card>
  );
};

export default OrderList;